
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden" style={{
      backgroundImage: 'url(https://public.readdy.ai/ai/img_res/2b76ff30b748146708589475cec2bc6b.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/80"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20 mb-6">
            <i className="ri-shield-check-line text-blue-300"></i>
            <span className="text-white text-sm">Secure VPN Solutions</span>
          </div>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Your Privacy,<br />Our Priority
        </h1>
        
        <p className="text-xl md:text-2xl text-blue-100 mb-12 max-w-3xl mx-auto leading-relaxed">
          Experience ultimate online security with our advanced VPN technology. Browse anonymously, protect your data, and access content freely from anywhere in the world.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap">
            Get Started Now
          </button>
          <button className="px-8 py-4 bg-transparent text-white border-2 border-white rounded-lg font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap">
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
}
